import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const PrivacyPolicy = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const [language, setLanguage] = useState('en');

    return (
        <section>
            <div className="inn-body-section">
                <div className="container">
                    <div className="page-head">
                        <h2 style={{ 'fontSize': '33px' }}>Privacy Policy</h2>
                        <div className="head-title">
                            <div className="hl-1"></div>
                            <div className="hl-2"></div>
                            <div className="hl-3"></div>
                        </div>
                        <p>Welcome to Younic Home. Please read this privacy policy carefully before using our website.</p>
                    </div>

                    <div className="content-section">
                        <div className='form-group text-center mb-4'>
                            <button
                                className={`btn mr-2 ${language === 'en' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => setLanguage('en')}
                            >
                                English
                            </button>
                            <button
                                className={`btn ${language === 'bn' ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => setLanguage('bn')}
                            >
                                বাংলা
                            </button>
                        </div>
                        <div className={`container mt-5 ${language === 'en' ? '' : 'd-none'}`}>
                            <section class="mb-4">
                                <strong>Administration & Management Policy</strong>
                                <ul>
                                    <li>The overall management responsibility of the hostel lies with the hostel manager/administrator.</li>
                                    <li>All residents must adhere to these rules and regulations.</li>
                                    <li>If any resident forms groups to disrupt the hostel environment, they will be warned, and if necessary, expelled.</li>
                                    <li>Any complaints or requests related to the hostel must be submitted in writing to the hostel manager.</li>
                                    <li>The management reserves the right to inspect any resident’s room if necessary.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Rent & Financial Policy</strong>
                                <ul>
                                    <li>The rent must be paid within the stipulated due date each month.</li>
                                    <li>If payment is delayed, a fine of BDT 50 per day will be added.</li>
                                    <li>If a resident checks out without providing a 60-day notice, the security deposit will not be refunded.</li>
                                    <li>Failure to pay rent within the due date may result in seat cancellation.</li>
                                    <li>Electricity bills will depend on usage and will be calculated based on a fixed rate.</li>
                                    <li>Gas, water, and internet bills are included in the monthly rent.</li>
                                    <li>The hostel management reserves the right to revise rent and other charges, with prior notice to residents.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Security & Entry Policy</strong>
                                <ul>
                                    <li>Residents must use the designated entrance, and the main gate will be closed after 10:00 PM.</li>
                                    <li>Residents must obtain permission from the management if they need to enter after the stipulated time.</li>
                                    <li>Residents are responsible for securing their valuables; the management will not be responsible for any loss or theft.</li>
                                    <li>CCTV cameras will monitor the main entrance and other key areas for security purposes.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Guest & Visitor Policy</strong>
                                <ul>
                                    <li>Residents may bring guests for a limited period with prior permission.</li>
                                    <li>If a guest wishes to stay overnight, they must pay the designated fee and obtain approval.</li>
                                    <li>If a resident keeps an unauthorized guest, they will be fined or expelled.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Rules & Discipline</strong>
                                <ul>
                                    <li>Drugs, smoking, gambling, and any illegal substances are strictly prohibited.</li>
                                    <li>Political activities and any form of religious or racial hate speech are strictly prohibited.</li>
                                    <li>Any form of harassment toward another resident will result in immediate expulsion.</li>
                                    <li>If a resident is involved in a serious offense, they must vacate the hostel within 2 hours.</li>
                                    <li>All residents must ensure peaceful coexistence.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Emergency & Medical Policy</strong>
                                <ul>
                                    <li>Emergency exit plans will be in place in case of natural disasters or fire.</li>
                                    <li>If a resident falls seriously ill, the management will inform their family and assist in hospitalization, but the resident must bear the medical costs.</li>
                                    <li>Basic first-aid facilities will be available for residents.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Maintenance & Repair Policy</strong>
                                <ul>
                                    <li>Residents are responsible for keeping their rooms and common areas clean.</li>
                                    <li>Any damage to furniture or equipment must be compensated by the resident.</li>
                                    <li>For repairs, residents must fill out a complaint form and submit it to the management.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Seat Cancellation & Check-Out Policy</strong>
                                <ul>
                                    <li>Residents must provide a 60-day notice before leaving the hostel.</li>
                                    <li>All pending dues must be cleared.</li>
                                    <li>Before vacating, a room inspection will be conducted, and any damages must be compensated by the resident.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Legal & Ethical Policy</strong>
                                <ul>
                                    <li>Any illegal activities, such as drug use, smoking, gambling, or criminal offenses, are strictly prohibited.</li>
                                    <li>Political activities are not allowed inside the hostel.</li>
                                    <li>If any resident harms another resident, legal action will be taken.</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>Special Guidelines</strong>
                                <ul>
                                    <li>The hostel management reserves the right to modify these terms at any time.</li>
                                    <li>Regular meetings will be held to inform residents about hostel rules.</li>
                                    <li>All complaints must be submitted in writing.</li>
                                </ul>
                            </section>

                            <div class="mt-5 text-center">
                                <strong>Final Statement:</strong>
                                <p className='mb-0'>These privacy policy are mandatory for all residents.</p>
                                <p className='mb-0'>The hostel management reserves the right to amend the rules at any time.</p>
                                <p>Following these policies will help ensure a well-disciplined, secure, and resident-friendly hostel environment.</p>
                            </div>
                        </div>
                        <div className={`container mt-5 ${language === 'bn' ? '' : 'd-none'}`}>
                            <section class="mb-4">
                                <strong>প্রশাসন ও ব্যবস্থাপনা নীতি</strong>
                                <ul>
                                    <li>হোস্টেলের সার্বিক ব্যবস্থাপনার দায়িত্ব হোস্টেল ম্যানেজার/প্রশাসকের উপর নির্ভরশীল।</li>
                                    <li>সব রেসিডেন্টদের এই নিয়মাবলি মেনে চলা বাধ্যতামূলক।</li>
                                    <li>যদি কোনো রেসিডেন্ট দলবদ্ধভাবে হোস্টেলের পরিবেশ বিঘ্নিত করে, তাহলে প্রথমে সতর্ক করা হবে এবং প্রয়োজনে বহিষ্কার করা হবে।</li>
                                    <li>হোস্টেল সংক্রান্ত যেকোনো অভিযোগ বা অনুরোধ লিখিতভাবে হোস্টেল ম্যানেজারের কাছে জমা দিতে হবে।</li>
                                    <li>প্রয়োজনে ব্যবস্থাপনা যেকোনো রেসিডেন্টের রুম পরিদর্শন করার অধিকার রাখে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>ভাড়া ও আর্থিক নীতি</strong>
                                <ul>
                                    <li>প্রতি মাসে নির্ধারিত তারিখের মধ্যে ভাড়া পরিশোধ করতে হবে।</li>
                                    <li>ভাড়ার পরিশোধ বিলম্বিত হলে প্রতিদিন ৫০ টাকা করে জরিমানা প্রযোজ্য হবে।</li>
                                    <li>৬০ দিনের নোটিশ ছাড়া রেসিডেন্ট চেক-আউট করলে নিরাপত্তা জামানত ফেরত দেওয়া হবে না।</li>
                                    <li>নির্ধারিত সময়ে ভাড়া পরিশোধ না করলে সিট বাতিল হতে পারে।</li>
                                    <li>বিদ্যুৎ বিল ব্যবহারের উপর নির্ভরশীল এবং নির্দিষ্ট হারে গণনা করা হবে।</li>
                                    <li>গ্যাস, পানি ও ইন্টারনেট বিল মাসিক ভাড়ার মধ্যে অন্তর্ভুক্ত।</li>
                                    <li>হোস্টেল ব্যবস্থাপনা প্রয়োজন হলে পূর্বে নোটিশ দিয়ে ভাড়া ও অন্যান্য চার্জ পরিবর্তনের অধিকার রাখে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>নিরাপত্তা ও প্রবেশ নীতি</strong>
                                <ul>
                                    <li>রেসিডেন্টদের নির্ধারিত প্রবেশপথ ব্যবহার করতে হবে এবং প্রধান ফটক রাত ১০টার পর বন্ধ থাকবে।</li>
                                    <li>নির্ধারিত সময়ের পর প্রবেশ করতে হলে ব্যবস্থাপনার অনুমতি নিতে হবে।</li>
                                    <li>নিজের মূল্যবান জিনিসের নিরাপত্তার দায়িত্ব রেসিডেন্টদের; ব্যবস্থাপনা কোনো ক্ষতির জন্য দায়ী থাকবে না।</li>
                                    <li>নিরাপত্তার জন্য মূল প্রবেশদ্বার ও গুরুত্বপূর্ণ এলাকায় সিসিটিভি ক্যামেরা থাকবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>অতিথি ও ভিজিটর নীতি</strong>
                                <ul>
                                    <li>রেসিডেন্টরা পূর্বানুমতি নিয়ে সীমিত সময়ের জন্য অতিথি আনতে পারবেন।</li>
                                    <li>অতিথিকে রাত যাপন করাতে হলে অনুমতি নিয়ে নির্ধারিত ফি প্রদান করতে হবে।</li>
                                    <li>অননুমোদিত অতিথি রাখলে রেসিডেন্টকে জরিমানা বা বহিষ্কার করা হতে পারে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>নিয়ম ও শৃঙ্খলা</strong>
                                <ul>
                                    <li>মাদক, ধূমপান, জুয়া এবং যেকোনো অবৈধ বস্তু সম্পূর্ণ নিষিদ্ধ।</li>
                                    <li>রাজনৈতিক কার্যক্রম ও ধর্ম বা বর্ণ ভিত্তিক ঘৃণাত্মক বক্তব্য সম্পূর্ণ নিষিদ্ধ।</li>
                                    <li>অন্য রেসিডেন্টকে হয়রানি করলে সঙ্গে সঙ্গে বহিষ্কার করা হবে।</li>
                                    <li>গুরুতর অপরাধে জড়িত হলে রেসিডেন্টকে ২ ঘণ্টার মধ্যে হোস্টেল ছাড়তে হবে।</li>
                                    <li>সব রেসিডেন্টদের শান্তিপূর্ণ সহাবস্থানে অংশ নিতে হবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>জরুরি ও চিকিৎসা নীতি</strong>
                                <ul>
                                    <li>প্রাকৃতিক দুর্যোগ বা অগ্নিকাণ্ডের সময় জরুরি নির্গমন পরিকল্পনা কার্যকর থাকবে।</li>
                                    <li>রেসিডেন্ট গুরুতর অসুস্থ হলে, ব্যবস্থাপনা তার পরিবারকে জানাবে এবং হাসপাতালে নেয়ার ব্যবস্থা করবে, তবে চিকিৎসার খরচ রেসিডেন্টকে বহন করতে হবে।</li>
                                    <li>প্রাথমিক চিকিৎসার জন্য মৌলিক ফার্স্ট-এইড সুবিধা থাকবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>রক্ষণাবেক্ষণ ও মেরামত নীতি</strong>
                                <ul>
                                    <li>রেসিডেন্টদের নিজ নিজ কক্ষ ও সাধারণ এলাকাগুলো পরিষ্কার রাখতে হবে।</li>
                                    <li>ফার্নিচার বা সরঞ্জামের ক্ষতি হলে রেসিডেন্টকে ক্ষতিপূরণ দিতে হবে।</li>
                                    <li>যেকোনো মেরামতের জন্য অভিযোগ ফর্ম পূরণ করে ব্যবস্থাপনার কাছে জমা দিতে হবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>সিট বাতিল ও চেক-আউট নীতি</strong>
                                <ul>
                                    <li>হোস্টেল ত্যাগের আগে রেসিডেন্টকে ৬০ দিনের নোটিশ দিতে হবে।</li>
                                    <li>সমস্ত বকেয়া বিল পরিশোধ করতে হবে।</li>
                                    <li>চেক-আউটের আগে রুম পরিদর্শন করা হবে এবং কোনো ক্ষতি হলে তা রেসিডেন্টকে বহন করতে হবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>আইনি ও নৈতিক নীতি</strong>
                                <ul>
                                    <li>মাদক সেবন, ধূমপান, জুয়া বা যেকোনো অপরাধমূলক কর্মকাণ্ড কঠোরভাবে নিষিদ্ধ।</li>
                                    <li>হোস্টেলের ভেতরে রাজনৈতিক কার্যক্রম নিষিদ্ধ।</li>
                                    <li>কোনো রেসিডেন্ট অন্যকে ক্ষতি করলে আইনানুগ ব্যবস্থা নেওয়া হবে।</li>
                                </ul>
                            </section>

                            <section class="mb-4">
                                <strong>বিশেষ নির্দেশনা</strong>
                                <ul>
                                    <li>হোস্টেল ব্যবস্থাপনা যেকোনো সময় এই নিয়মাবলি পরিবর্তন করতে পারে।</li>
                                    <li>রেসিডেন্টদের নিয়মাবলি জানাতে নিয়মিত সভা অনুষ্ঠিত হবে।</li>
                                    <li>সব অভিযোগ লিখিত আকারে জমা দিতে হবে।</li>
                                </ul>
                            </section>

                            <div class="mt-5 text-center">
                                <strong>চূড়ান্ত বিবৃতি:</strong>
                                <p className='mb-0'>এই নীতিমালা সকল রেসিডেন্টের জন্য বাধ্যতামূলক।</p>
                                <p className='mb-0'>হোস্টেল ব্যবস্থাপনা যেকোনো সময় নিয়ম পরিবর্তনের অধিকার রাখে।</p>
                                <p>এই নীতিমালা অনুসরণ করলে একটি শৃঙ্খলাপূর্ণ, নিরাপদ এবং বন্ধুত্বপূর্ণ হোস্টেল পরিবেশ নিশ্চিত করা সম্ভব হবে।</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default PrivacyPolicy;
